import { createContext, useContext } from 'react';

type RefreshContextValue = {
    isRefreshing: boolean;
    setIsRefreshing: (b: boolean) => void;
    needRefresh: boolean;
    setNeedRefresh: (b: boolean) => void;
    refreshLines: () => Promise<void>;
};

const defaultValue: RefreshContextValue = {
    isRefreshing: false,
    setIsRefreshing: () => {},
    needRefresh: false,
    setNeedRefresh: () => {},
    refreshLines: async () => {},
};

const RefreshContext = createContext<RefreshContextValue>(defaultValue);
export const useRefresh = () => useContext(RefreshContext);

export default RefreshContext;